import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../../store/actions/adminActions";
import { Actions as AUTHENTICATIONACTIONS } from "../../../store/actions/authenticationActions";
import { Actions as ADVISORACTIONS } from "../../../store/actions/advisorActions";
import { Actions as COURSEACTIONS } from "../../../store/actions/courseActions";
import { Actions as WEBINARACTIONS } from "../../../store/actions/webinarActions";
import { XMarkIcon } from "@heroicons/react/20/solid";
import DatePicker from "react-datepicker";
import Select from "react-select";
import ReactFileReader from "react-file-reader";
import AttendeeRow from "./AttendeeRow";
import { NotificationManager } from "react-notifications";

const CertificateModal = ({
	modalStatus,
	closeModal,
	userInfo,
	courseTrainerList,
	handleWebinarAttendanceFiles,
	courseWebinarAttendanceList,
	getEventbriteEvents,
	webinars,
	webinarOptions,
	sendCertificates,
	addNewAttendee,
	setAllCertificatesStatus,
	attendees,
}) => {
	const [formData, setFormData] = useState({});

	const handleSubmit = (event) => {
		event.preventDefault();

		if (formData.attendees.length == 0) {
			NotificationManager.error("No attendees selected!", "Saving Certificates");
			return;
		}

		sendCertificates(formData);
		// closeModal();
	};

	const updateField = ({ subfield, name, value }) => {
		console.debug(value);
		if (subfield) {
			setFormData({
				...formData,
				[subfield]: {
					...[subfield],
					[name]: value,
				},
			});
			return;
		}
		setFormData({
			...formData,
			[name]: value,
		});
	};

	useEffect(() => {
		if (!webinars.length) getEventbriteEvents();
	}, []);

	if (!modalStatus) return null;
	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}
		>
			<div
				className="modal-dialog"
				style={{ width: "60%" }}
			>
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div
							className="block-header bg-primary-dark"
							style={{ padding: 20, position: "sticky", top: 0, zIndex: 50 }}
						>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={() => {
											handleWebinarAttendanceFiles();
											closeModal();
										}}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">Create Certificate</h3>
							<div className="clearfix"></div>
						</div>
						{userInfo && (
							<form onSubmit={handleSubmit}>
								<div className="block-content">
									<div className="form-group col-sm-12">
										<div className="form-material pl-0 col-sm-6">
											<label htmlFor="courseName">Name of Course</label>
											<input
												name="courseName"
												id="courseName"
												value={formData.courseName || ""}
												onChange={(e) => {
													updateField({ name: e.target.name, value: e.target.value });
												}}
											/>
										</div>
										<div className="form-material pl-0 col-sm-6">
											<label htmlFor="courseDate">Date of Course</label>
											<DatePicker
												id="courseDate"
												name="courseDate"
												selected={formData.courseDate || new Date()}
												onChange={(e) => {
													updateField({ name: "courseDate", value: e });
												}}
											/>
										</div>
										<div className="form-material pl-0 col-sm-6">
											<label htmlFor="courseDuration">Duration of Course (minutes)</label>
											<input
												id="courseDuration"
												name="courseDuration"
												type="number"
												value={formData.courseDuration || ""}
												onChange={(e) => {
													updateField({ name: e.target.name, value: e.target.value });
												}}
											/>
										</div>
										<div className="form-material pl-0 col-sm-6">
											<label htmlFor="trainer">Trainer of Course</label>
											<Select
												id="trainer"
												name="trainer"
												options={courseTrainerList}
												selected={formData.trainer || ""}
												onChange={(e) => {
													updateField({ name: "trainer", value: e.value });
												}}
											/>
										</div>
										<div className="form-material pl-0 col-sm-6">
											<label htmlFor="webinarPresets">Webinar Presets</label>
											<Select
												id="webinarPresets"
												name="webinarPresets"
												options={webinarOptions}
												onChange={(e) => {
													const selectedWebinar = webinars.find(
														(webinar) => webinar.webinarID === e.value,
													);
													setFormData({
														...formData,
														["courseName"]: selectedWebinar.title,
														["courseDate"]: new Date(selectedWebinar.date),
														["courseDuration"]: selectedWebinar.duration,
													});
												}}
											/>
										</div>
									</div>
								</div>
								<div className="block-content">
									<div className="btn btn-default">
										<ReactFileReader
											fileTypes={[".csv", ".dbf", ".*", "application/dbase", "application/dbf"]}
											handleFiles={handleWebinarAttendanceFiles}
										>
											Upload Attendees
										</ReactFileReader>
									</div>
									<div
										className="btn btn-default"
										style={{ marginLeft: 5 }}
										onClick={() => addNewAttendee()}
									>
										Add New Attendee
									</div>
									{courseWebinarAttendanceList?.length > 0 && (
										<div
											className="btn btn-default"
											style={{ marginLeft: 5 }}
											onClick={() => handleWebinarAttendanceFiles()}
										>
											Clear Attendees
										</div>
									)}
									<table
										id="table-attendees"
										className="table-responsive table table-hover"
									>
										<thead>
											<tr>
												<th style={{ textAlign: "center" }}>Name</th>
												<th style={{ textAlign: "center" }}>Email</th>
												<th width="5%">
													<label
														className="css-input switch switch-sm switch-success"
														style={{ padding: 0 }}
													>
														<input
															type="checkbox"
															className="checkbox-toggle"
															disabled={courseWebinarAttendanceList?.length == 0}
															onChange={(e) => {
																setAllCertificatesStatus(e.target.checked);
															}}
														/>
														<span />
													</label>
												</th>
											</tr>
										</thead>
										<tbody>
											{courseWebinarAttendanceList?.length > 0 ? (
												courseWebinarAttendanceList?.map((attendee, index) => (
													<AttendeeRow
														key={index}
														/*attendee={attendee}*/ position={index}
													/>
												))
											) : (
												<tr>
													<th colSpan={3}>No attendees</th>
												</tr>
											)}
										</tbody>
									</table>
								</div>
								<button
									className="btn btn-success pull-right"
									type="submit"
									style={{ marginBottom: 10, marginRight: 10 }}
									disabled={
										courseWebinarAttendanceList?.length == 0 ||
										!formData?.courseDuration ||
										!formData?.courseName ||
										!formData?.trainer
									}
									onClick={() => {
										let newAttendees = [];

										for (const i in attendees) {
											const attendee = attendees[i];

											//If Check box is ticked, add to newAttendees
											if (attendee["Certificate Status"]) newAttendees.push(attendee);
										}

										updateField({
											name: "attendees",
											value: newAttendees,
										});
									}}
								>
									Submit
								</button>
							</form>
						)}
						<div className="clearfix"></div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const userInfo = state.admin?.getUser || {};
	const organisations = [
		userInfo?.isEmployee ? "Employee" : undefined,
		userInfo.isAdvisor ? "Advisor" : undefined,
		...(Array.isArray(userInfo.organisations) ? userInfo.organisations : []),
	]?.filter((item) => !!item);

	const courseTrainerList = [
		{ label: "Jonathan Mifsud", value: "Jonathan Mifsud" },
		{ label: "Jeremy Mifsud", value: "Jeremy Mifsud" },
	];

	const webinarOptions = state.webinars?.list?.map((webinar) => ({ label: webinar.title, value: webinar.webinarID }));
	return {
		modalStatus: state.admin?.getCertificateModal,
		organisations: state?.admin?.organisations || [],
		advisors: state?.advisors?.advisorList || [],
		userInfo: { ...userInfo, organisations },
		courseTrainerList,
		courseWebinarAttendanceList: state?.courseWebinarAttendanceImport?.data || [],
		webinars: state.webinars.list,
		webinarOptions,
		attendees: state?.courseWebinarAttendanceImport?.data,
	};
};
const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(ACTIONS.getCertificateModal()),
	handleWebinarAttendanceFiles: (files) => dispatch(COURSEACTIONS.handleWebinarAttendanceFiles(files)),
	getEventbriteEvents: () => dispatch(WEBINARACTIONS.getEventbriteEvents()),
	sendCertificates: (data) => dispatch(ACTIONS.sendCertificates(data)),
	addNewAttendee: () => dispatch(COURSEACTIONS.addNewAttendee()),
	setAllCertificatesStatus: (status) => dispatch(COURSEACTIONS.setAllCertificatesStatus(status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CertificateModal);
